// client/src/services/postalGroupsService.js
// Delad klient mot /api/health-data/postal-groups. Hanterar 3-skala-mönstret
// (postnummer/stad/land) och dual-call (symptom-filtrerat + totalt).

import API_CONFIG from '../config/apiConfig';

const ENDPOINT = `${API_CONFIG.baseUrl}/health-data/postal-groups`;

function buildUrl({ week, symptoms, postalCode, city, groupBy, matchMode, limit }) {
  const params = new URLSearchParams({ week: String(week) });
  if (Array.isArray(symptoms) && symptoms.length > 0) {
    params.set('symptoms', symptoms.join(','));
  }
  if (postalCode) params.set('postalCode', postalCode);
  if (city) params.set('city', city);
  if (groupBy) params.set('groupBy', groupBy);
  if (matchMode) params.set('matchMode', matchMode);
  if (limit != null) params.set('limit', String(limit));
  return `${ENDPOINT}?${params}`;
}

/**
 * Primitiv: ett enkelt anrop mot /postal-groups. Returnerar raw API-svar
 * { success, data, metadata }.
 */
export async function fetchPostalGroups(opts) {
  const res = await fetch(buildUrl(opts));
  if (!res.ok) {
    return { success: false, data: [], error: `HTTP ${res.status}` };
  }
  return res.json();
}

/**
 * Dual-call för en skala: symptom-filtrerad + samma anrop utan symptom (för total).
 * Använd groupBy='city' / 'country' för att tvinga server-aggregering, annars trunkeras
 * resultatet av $limit: 100 postnummer i pipelinen.
 *
 * Returnerar { withSymptoms, total } — båda raw API-svar.
 */
export async function fetchScopeWithTotal({ week, symptoms, postalCode, city, groupBy }) {
  const [withSymptoms, total] = await Promise.all([
    fetchPostalGroups({ week, symptoms, postalCode, city, groupBy }),
    fetchPostalGroups({ week, postalCode, city, groupBy })
  ]);
  return { withSymptoms, total };
}
